import { FilterCompTypes } from 'app/ComponentLibrary/Filter/utils';
import { calculateTreeCount } from 'app/components/Common/TreeView/TreeViewHelpers';

export enum notificationFilterName {
  communicationType = 'communicationType',
  initiatedBy = 'initiatedBy',
  communicationDirection = 'communicationDirection',
  status = 'status',
}

export const defaultNotificationChips = {
  [notificationFilterName.communicationType]: [],
  [notificationFilterName.initiatedBy]: [{ label: 'Me', value: 'Me', enableDelete: false }],
  [notificationFilterName.communicationDirection]: [],
  [notificationFilterName.status]: [],
};

export const defaultNotificationValues = {
  [notificationFilterName.communicationType]: [],
  [notificationFilterName.initiatedBy]: [{ id: 0, label: 'Me', value: 'Me' }],
  [notificationFilterName.communicationDirection]: [],
  [notificationFilterName.status]: [],
};

const communicationTypeOpts = ['SMS', 'Call', 'Email'];
const initiatedByOpts = ['Me'];
const communicationDirectionOpts = ['Inbound', 'Outbound'];

export const getNotificationFilterSpecs = () => [
  {
    filterName: 'Communication Type',
    name: notificationFilterName.communicationType,
    type: FilterCompTypes.TYPEAHEADDROPDOWN,
    options: getOpts(communicationTypeOpts),
    isMultiSelect: true,
  },
  {
    filterName: 'Initiated By',
    name: notificationFilterName.initiatedBy,
    type: FilterCompTypes.TYPEAHEADDROPDOWN,
    options: getOpts(initiatedByOpts),
    isMultiSelect: true,
    isDisabled: true,
  },
  {
    filterName: 'Communication Direction',
    name: notificationFilterName.communicationDirection,
    type: FilterCompTypes.TYPEAHEADDROPDOWN,
    options: getOpts(communicationDirectionOpts),
    isMultiSelect: true,
  },
  {
    filterName: 'Status',
    name: notificationFilterName.status,
    type: FilterCompTypes.TREE,
    options: statusOpts,
    isMultiSelect: true,
    version2: true,
    returnsObjectAsValue: true,
    size: 'large',
    customSelectedCount: value => calculateTreeCount(value),
  },
];

const getOpts = options =>
  options.map((opt, i) => ({
    id: i,
    name: opt,
    value: opt,
  }));

export const NotificationDefaultValues = {
  [notificationFilterName.communicationType]: [
    {
      id: 0,
      name: 'Call',
      value: 'Call',
    },
  ],
  [notificationFilterName.initiatedBy]: [
    {
      id: 0,
      name: 'Me',
      value: 'Me',
    },
  ],
  [notificationFilterName.communicationDirection]: [
    {
      id: 0,
      name: 'Outbound',
      value: 'Outbound',
    },
  ],
  [notificationFilterName.status]: [],
};

const statusOpts = [
  {
    value: 'Call',
    name: 'Call',
    children: [
      {
        value: 'Could Not Connect',
        name: 'Could Not Connect',
      },
      {
        value: 'Left Message',
        name: 'Left Message',
      },
      {
        value: 'Phone Disconnected',
        name: 'Phone Disconnected',
      },
      {
        value: 'Spoke To Candidate',
        name: 'Spoke To Candidate',
      },
    ],
  },
  {
    value: 'Email',
    name: 'Email',
    children: [
      {
        value: 'Processing',
        name: 'Processing',
      },
      {
        value: 'Processed',
        name: 'Processed',
      },
      {
        value: 'Dropped',
        name: 'Dropped',
      },
      {
        value: 'Bounce',
        name: 'Bounce',
      },
      {
        value: 'Deferred',
        name: 'Deferred',
      },
      {
        value: 'Delivered',
        name: 'Delivered',
      },
      {
        value: 'Open',
        name: 'Open',
      },
      {
        value: 'Click',
        name: 'Click',
      },
    ],
  },
];
